/* eslint-disable no-param-reassign,no-restricted-globals */
import store from '../store';
import { capitalizeFirstLetter } from './strings';

const helpers = {
  $isAdmin() {
    if (store.getters['auth/currentUser']) {
      return store.getters['auth/currentUser'].role === 'admin';
    }
    return false;
  },

  $isCurrentUser(id) {
    if (store.getters['auth/currentUser']) {
      return store.getters['auth/currentUser'].id === id;
    }
    return false;
  },

  $capitalizeFirstLetter(s) {
    return capitalizeFirstLetter(s);
  },

  $backendUrl(path) {
    return process.env.VUE_APP_API_ENDPOINT + path;
  },

  $previewBackendUrl(path) {
    return `${this.$backendUrl(path)}page_preview_key=${process.env.VUE_APP_PAGE_PREVIEW_KEY}`;
  },
};

function registerHelpers(Vue) {
  Object.keys(helpers).forEach((helper) => {
    Vue.prototype[helper] = helpers[helper];
  });
}

export default registerHelpers;
